// 프로젝트 관리 타입 정의

// 프로젝트 상태
export type ProjectStatus = 'planning' | 'active' | 'on_hold' | 'completed' | 'cancelled';

// 프로젝트 우선순위
export type ProjectPriority = 'low' | 'medium' | 'high' | 'critical';

// 작업 상태
export type TaskStatus = 'open' | 'in_progress' | 'pending_review' | 'completed' | 'cancelled';

// 작업 우선순위
export type TaskPriority = 'low' | 'medium' | 'high' | 'urgent';

// 타임시트 상태
export type TimesheetStatus = 'draft' | 'submitted' | 'approved' | 'rejected';

// 프로젝트
export interface Project {
  id: string;
  code: string;
  name: string;
  status: ProjectStatus;
  priority: ProjectPriority;
  customerId?: string;
  customerName?: string;
  projectManager?: string;
  projectManagerName?: string;
  startDate: string;
  endDate: string;
  progress: number;
  budget: number;
  actualCost: number;
  description?: string;
  department?: string;
  createdAt: string;
  updatedAt: string;
}

// 작업
export interface Task {
  id: string;
  code: string;
  name: string;
  projectId: string;
  projectName: string;
  status: TaskStatus;
  priority: TaskPriority;
  assignedTo?: string;
  assignedToName?: string;
  startDate?: string;
  endDate?: string;
  expectedHours: number;
  actualHours: number;
  progress: number;
  parentTaskId?: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

// 타임시트
export interface Timesheet {
  id: string;
  code: string;
  employeeId: string;
  employeeName: string;
  status: TimesheetStatus;
  startDate: string;
  endDate: string;
  totalHours: number;
  billingHours: number;
  entries: TimesheetEntry[];
  remarks?: string;
  approvedBy?: string;
  approvedAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

// 타임시트 항목
export interface TimesheetEntry {
  id: string;
  date: string;
  projectId: string;
  projectName: string;
  taskId?: string;
  taskName?: string;
  hours: number;
  isBillable: boolean;
  description?: string;
}

// 마일스톤
export interface Milestone {
  id: string;
  projectId: string;
  projectName: string;
  name: string;
  dueDate: string;
  status: 'pending' | 'completed' | 'overdue';
  description?: string;
}

// 상태 레이블 및 색상
export const projectStatusConfig: Record<ProjectStatus, { label: string; color: string }> = {
  planning: { label: '계획', color: 'gray' },
  active: { label: '진행중', color: 'blue' },
  on_hold: { label: '보류', color: 'yellow' },
  completed: { label: '완료', color: 'green' },
  cancelled: { label: '취소', color: 'red' },
};

export const projectPriorityConfig: Record<ProjectPriority, { label: string; color: string }> = {
  low: { label: '낮음', color: 'gray' },
  medium: { label: '보통', color: 'blue' },
  high: { label: '높음', color: 'orange' },
  critical: { label: '긴급', color: 'red' },
};

export const taskStatusConfig: Record<TaskStatus, { label: string; color: string }> = {
  open: { label: '대기', color: 'gray' },
  in_progress: { label: '진행중', color: 'blue' },
  pending_review: { label: '검토중', color: 'yellow' },
  completed: { label: '완료', color: 'green' },
  cancelled: { label: '취소', color: 'red' },
};

export const taskPriorityConfig: Record<TaskPriority, { label: string; color: string }> = {
  low: { label: '낮음', color: 'gray' },
  medium: { label: '보통', color: 'blue' },
  high: { label: '높음', color: 'orange' },
  urgent: { label: '긴급', color: 'red' },
};

export const timesheetStatusConfig: Record<TimesheetStatus, { label: string; color: string }> = {
  draft: { label: '작성중', color: 'gray' },
  submitted: { label: '제출됨', color: 'blue' },
  approved: { label: '승인됨', color: 'green' },
  rejected: { label: '반려됨', color: 'red' },
};
